/* ==========================================================================
   ROSEVORA — tema betiği
   ========================================================================== */
(function () {
  'use strict';

  const $  = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------------- Toast ---------------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2800);
  }
  window.rosevoraToast = toast;

  /* ---------------- Geri sayım ---------------- */
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(el) {
    const mode     = el.dataset.mode || 'evergreen';
    const hours    = parseFloat(el.dataset.hours || '24');
    const endDate  = el.dataset.endDate;
    const storeKey = 'rosevora_cd_' + (el.dataset.key || 'default');
    const expired  = el.dataset.expiredText || '';

    let target;
    if (mode === 'fixed' && endDate) {
      target = new Date(endDate).getTime();
      if (isNaN(target)) target = Date.now() + hours * 3600000;
    } else {
      // Evergreen: ziyaretçi başına sıfırlanan sayaç
      const saved = localStorage.getItem(storeKey);
      if (saved && parseInt(saved, 10) > Date.now()) {
        target = parseInt(saved, 10);
      } else {
        target = Date.now() + hours * 3600000;
        localStorage.setItem(storeKey, String(target));
      }
    }

    const dEl = $('[data-cd-d]', el), hEl = $('[data-cd-h]', el),
          mEl = $('[data-cd-m]', el), sEl = $('[data-cd-s]', el);

    function tick() {
      let diff = target - Date.now();
      if (diff <= 0) {
        if (mode === 'evergreen') {
          target = Date.now() + hours * 3600000;
          localStorage.setItem(storeKey, String(target));
          diff = hours * 3600000;
        } else {
          clearInterval(timer);
          if (expired) el.innerHTML = '<span class="countdown__label">' + expired + '</span>';
          return;
        }
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(dEl ? h : h + d * 24);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    const timer = setInterval(tick, 1000);
  }

  /* ---------------- SSS ---------------- */
  function initFaq(root) {
    $$('.faq__q', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faq__item');
        const wasOpen = item.classList.contains('is-open');
        const single = item.closest('[data-faq-single="true"]');
        if (single) $$('.faq__item', single).forEach((i) => i.classList.remove('is-open'));
        item.classList.toggle('is-open', !wasOpen);
        btn.setAttribute('aria-expanded', String(!wasOpen));
      });
    });
  }

  /* ---------------- Yorum filtreleri + daha fazla ---------------- */
  function initReviews(root) {
    const grid = $('[data-reviews-grid]', root);
    if (!grid) return;
    const step = parseInt(root.dataset.perPage || '6', 10);
    let shown = step;
    let filter = 'all';

    const moreBtn = $('[data-reviews-more]', root);

    function apply() {
      const cards = $$('.review-card', grid);
      let visible = 0;
      cards.forEach((card) => {
        const hasMedia = card.dataset.hasMedia === 'true';
        const stars = card.dataset.stars;
        let match = true;
        if (filter === 'media') match = hasMedia;
        else if (filter === '5') match = stars === '5';
        else if (filter === '4') match = stars === '4';
        if (match && visible < shown) { card.style.display = ''; visible++; }
        else card.style.display = 'none';
      });
      const total = cards.filter((c) => {
        if (filter === 'media') return c.dataset.hasMedia === 'true';
        if (filter === '5') return c.dataset.stars === '5';
        if (filter === '4') return c.dataset.stars === '4';
        return true;
      }).length;
      if (moreBtn) moreBtn.style.display = visible >= total ? 'none' : '';
    }

    $$('.review-filter', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('.review-filter', root).forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        filter = btn.dataset.filter;
        shown = step;
        apply();
      });
    });

    if (moreBtn) moreBtn.addEventListener('click', () => { shown += step; apply(); });
    apply();
  }

  /* ---------------- Görsel büyüteç ---------------- */
  let lightbox;
  function openLightbox(src) {
    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'lightbox';
      lightbox.innerHTML = '<button class="lightbox__close" aria-label="Kapat">&times;</button><img alt="">';
      document.body.appendChild(lightbox);
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox || e.target.classList.contains('lightbox__close')) {
          lightbox.classList.remove('is-open');
        }
      });
    }
    $('img', lightbox).src = src;
    lightbox.classList.add('is-open');
  }
  document.addEventListener('click', (e) => {
    const img = e.target.closest('[data-lightbox]');
    if (img) openLightbox(img.dataset.lightbox || img.src);
  });

  /* ---------------- Önce / Sonra ---------------- */
  function initBeforeAfter(el) {
    const after = $('.ba-after', el);
    const handle = $('.ba-handle', el);
    if (!after || !handle) return;
    let dragging = false;

    function move(clientX) {
      const rect = el.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(2, Math.min(98, pct));
      after.style.width = pct + '%';
      handle.style.left = pct + '%';
    }
    const start = () => { dragging = true; };
    const stop  = () => { dragging = false; };

    handle.addEventListener('mousedown', start);
    handle.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mouseup', stop);
    window.addEventListener('touchend', stop);
    window.addEventListener('mousemove', (e) => { if (dragging) move(e.clientX); });
    window.addEventListener('touchmove', (e) => { if (dragging) move(e.touches[0].clientX); }, { passive: true });
    el.addEventListener('click', (e) => { if (!e.target.closest('.ba-handle')) move(e.clientX); });
  }

  /* ---------------- Kupon pop-up ---------------- */
  function initPopup() {
    const overlay = $('[data-popup]');
    if (!overlay) return;
    const key = 'rosevora_popup_closed';
    const days = parseInt(overlay.dataset.frequency || '3', 10);
    const delay = parseInt(overlay.dataset.delay || '6', 10) * 1000;

    const closedAt = parseInt(localStorage.getItem(key) || '0', 10);
    if (closedAt && Date.now() - closedAt < days * 86400000) return;
    if (sessionStorage.getItem('rosevora_popup_seen')) return;

    function open() {
      overlay.classList.add('is-visible');
      requestAnimationFrame(() => overlay.classList.add('is-shown'));
      sessionStorage.setItem('rosevora_popup_seen', '1');
    }
    function close() {
      overlay.classList.remove('is-shown');
      localStorage.setItem(key, String(Date.now()));
      setTimeout(() => overlay.classList.remove('is-visible'), 350);
    }

    setTimeout(open, delay);

    // Çıkış niyeti
    document.addEventListener('mouseout', function onOut(e) {
      if (e.clientY < 8 && !sessionStorage.getItem('rosevora_popup_seen')) {
        open();
        document.removeEventListener('mouseout', onOut);
      }
    });

    $$('[data-popup-close]', overlay).forEach((b) => b.addEventListener('click', close));
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-shown')) close();
    });
  }

  /* ---------------- Kupon kodu kopyala ---------------- */
  document.addEventListener('click', (e) => {
    const code = e.target.closest('[data-copy-code]');
    if (!code) return;
    const value = code.dataset.copyCode || code.textContent.trim();
    navigator.clipboard?.writeText(value).then(
      () => toast('Kupon kodu kopyalandı: ' + value),
      () => toast('Kod: ' + value)
    );
  });

  /* ---------------- Mobil menü ---------------- */
  function initMobileMenu() {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    $$('[data-menu-open]').forEach((b) =>
      b.addEventListener('click', () => {
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      })
    );
    $$('[data-menu-close]', menu).forEach((b) =>
      b.addEventListener('click', () => {
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      })
    );
  }

  /* ---------------- Sepet çekmecesi ---------------- */
  function cartDrawer() {
    return { el: $('[data-cart-drawer]'), backdrop: $('[data-cart-backdrop]') };
  }
  function openCart() {
    const { el, backdrop } = cartDrawer();
    if (!el) return;
    el.classList.add('is-open');
    backdrop && backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    const { el, backdrop } = cartDrawer();
    if (!el) return;
    el.classList.remove('is-open');
    backdrop && backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function refreshCart() {
    try {
      const res = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-drawer-content]', doc);
      const current = $('[data-cart-drawer-content]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;

      const cart = await (await fetch('/cart.js')).json();
      $$('[data-cart-count]').forEach((n) => {
        n.textContent = cart.item_count;
        n.style.display = cart.item_count > 0 ? '' : 'none';
      });
    } catch (err) { /* sessizce geç */ }
  }
  window.rosevoraRefreshCart = refreshCart;

  function initCart() {
    $$('[data-cart-open]').forEach((b) =>
      b.addEventListener('click', (e) => {
        if (b.dataset.cartOpen === 'drawer') { e.preventDefault(); openCart(); }
      })
    );
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-close]')) closeCart();
      if (e.target.closest('[data-cart-backdrop]')) closeCart();
    });

    // Sepette adet değiştirme / kaldırma
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-cart-change]');
      if (!btn) return;
      e.preventDefault();
      const line = btn.dataset.line;
      const qty = btn.dataset.cartChange;
      btn.disabled = true;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
      });
      await refreshCart();
      btn.disabled = false;
    });
  }

  /* ---------------- Ürün formu (AJAX sepete ekle) ---------------- */
  function initProductForm(form) {
    form.addEventListener('submit', async (e) => {
      if (form.dataset.ajax === 'false') return;
      e.preventDefault();
      const btn = $('[data-atc-btn]', form);
      const original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'EKLENİYOR...'; }

      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        await refreshCart();
        if (btn) { btn.innerHTML = '✓ SEPETE EKLENDİ'; }
        if (form.dataset.cartType === 'drawer') openCart();
        else toast('Ürün sepete eklendi');
        setTimeout(() => { if (btn) { btn.innerHTML = original; btn.disabled = false; } }, 1600);
      } catch (err) {
        toast(err.message || 'Bir hata oluştu');
        if (btn) { btn.innerHTML = original; btn.disabled = false; }
      }
    });

    // "ŞİMDİ AL": sepete ekle, sonra doğrudan ödemeye git
    const buyNow = $('[data-buy-now]', form);
    if (buyNow) {
      buyNow.addEventListener('click', async () => {
        const original = buyNow.innerHTML;
        buyNow.disabled = true;
        buyNow.innerHTML = 'YÖNLENDİRİLİYOR...';
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
          const data = await res.json();
          if (data.status) throw new Error(data.description || data.message);
          window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
        } catch (err) {
          toast(err.message || 'Bir hata oluştu');
          buyNow.innerHTML = original;
          buyNow.disabled = false;
        }
      });
    }
  }

  /* ---------------- Adet seçici ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = $('input', btn.closest('.qty'));
    const min = parseInt(input.min || '1', 10);
    let v = parseInt(input.value || '1', 10);
    v += btn.dataset.qty === 'up' ? 1 : -1;
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Varyant seçimi ---------------- */
  function initVariants(root) {
    const data = $('[data-variant-json]', root);
    if (!data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-price]', root);
    const compareEl = $('[data-compare-price]', root);
    const savingEl = $('[data-saving]', root);
    const atcBtn = $('[data-atc-btn]', root);
    const money = root.dataset.moneyFormat || '{{amount}} TL';

    function formatMoney(cents) {
      const value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return money.replace(/\{\{\s*amount\s*\}\}/, value)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('tr-TR'))
                  .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value);
    }

    function selectedOptions() {
      return $$('[data-option-index]', root).map((group) => {
        const active = $('.variant-pill.is-active', group);
        return active ? active.dataset.value : null;
      });
    }

    function update() {
      const opts = selectedOptions();
      const match = variants.find((v) =>
        opts.every((o, i) => o === null || v.options[i] === o)
      );
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
          if (savingEl) {
            const pct = Math.round((1 - match.price / match.compare_at_price) * 100);
            savingEl.textContent = '%' + pct + ' İNDİRİM';
            savingEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (savingEl) savingEl.style.display = 'none';
        }
      }
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        if (!match.available) atcBtn.innerHTML = 'TÜKENDİ';
        else atcBtn.innerHTML = atcBtn.dataset.label || 'SEPETE EKLE';
      }
      // Sticky çubuk fiyatı
      const stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);

      if (match.featured_image && match.featured_image.src) {
        const main = $('[data-main-image]', root);
        if (main) main.src = match.featured_image.src;
      }
      history.replaceState({}, '', '?variant=' + match.id);
    }

    $$('[data-option-index]', root).forEach((group) => {
      $$('.variant-pill', group).forEach((pill) => {
        pill.addEventListener('click', () => {
          $$('.variant-pill', group).forEach((p) => p.classList.remove('is-active'));
          pill.classList.add('is-active');
          update();
        });
      });
    });

    // Paket (bundle) seçici
    $$('[data-bundle]', root).forEach((bundle) => {
      bundle.addEventListener('click', () => {
        $$('[data-bundle]', root).forEach((b) => b.classList.remove('is-active'));
        bundle.classList.add('is-active');
        const qtyInput = $('[name="quantity"]', root);
        if (qtyInput) qtyInput.value = bundle.dataset.bundle;
        const vId = bundle.dataset.variantId;
        if (vId && idInput) idInput.value = vId;
      });
    });
  }

  /* ---------------- Ürün galerisi ---------------- */
  function initGallery(root) {
    const main = $('[data-main-image]', root);
    if (!main) return;
    $$('[data-thumb]', root).forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('[data-thumb]', root).forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        main.src = btn.dataset.thumb;
        main.srcset = '';
      });
    });
  }

  /* ---------------- Yapışkan sepete ekle ---------------- */
  function initStickyAtc() {
    const bar = $('[data-sticky-atc]');
    const trigger = $('[data-atc-anchor]');
    if (!bar || !trigger) return;
    document.body.classList.add('has-sticky-atc');
    const io = new IntersectionObserver(
      ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0),
      { threshold: 0 }
    );
    io.observe(trigger);
    $('[data-sticky-buy]', bar)?.addEventListener('click', () => {
      const form = $('[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ---------------- Canlı ziyaretçi sayacı ---------------- */
  function initVisitors(el) {
    const min = parseInt(el.dataset.min || '30', 10);
    const max = parseInt(el.dataset.max || '80', 10);
    const num = $('[data-visitor-num]', el);
    let current = Math.floor(Math.random() * (max - min + 1)) + min;
    num.textContent = current;
    setInterval(() => {
      current += Math.random() > 0.5 ? 1 : -1;
      current = Math.max(min, Math.min(max, current));
      num.textContent = current;
    }, 4500);
  }

  /* ---------------- Görünürlük animasyonu ---------------- */
  function initReveal() {
    const els = $$('.reveal');
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }),
      { threshold: 0.12, rootMargin: '0px 0px -60px' }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ---------------- Başlat ---------------- */
  function boot(scope) {
    const root = scope || document;
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-before-after]', root).forEach(initBeforeAfter);
    $$('[data-reviews]', root).forEach(initReviews);
    $$('[data-product-root]', root).forEach((el) => { initVariants(el); initGallery(el); });
    $$('[data-product-form]', root).forEach(initProductForm);
    $$('[data-visitors]', root).forEach(initVisitors);
    initFaq(root);
    initReveal();
  }

  document.addEventListener('DOMContentLoaded', () => {
    boot();
    initPopup();
    initMobileMenu();
    initCart();
    initStickyAtc();
  });

  // Tema editörü desteği
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const popup = $('[data-popup]', e.target);
    if (popup) { popup.classList.add('is-visible'); requestAnimationFrame(() => popup.classList.add('is-shown')); }
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const popup = $('[data-popup]', e.target);
    if (popup) { popup.classList.remove('is-shown'); popup.classList.remove('is-visible'); }
  });
})();
